import React from "react";

const NftProperties = () => {
    return (
        <>
            <div className="_property_auction_wrapper">
                <div className="_property_auction_wrap">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <div className="_property_auction_card_wrap">
                                    <div className="_property_auction_card_head">
                                        <h6 className="_property_auction_card_head_txt">Properties</h6>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                        <div className="_property_auction_card">
                                            <h6 className="_property_auction_card_cont1">Background</h6>
                                            <p className="_property_auction_card_cont2">Yellow</p>
                                            <p className="_property_auction_card_cont3">11% have this trait
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                        <div className="_property_auction_card">
                                            <h6 className="_property_auction_card_cont1">Base</h6>
                                            <p className="_property_auction_card_cont2">Blue</p>
                                            <p className="_property_auction_card_cont3">10% have this trait
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                        <div className="_property_auction_card">
                                            <h6 className="_property_auction_card_cont1">Extra</h6>
                                            <p className="_property_auction_card_cont2">None</p>
                                            <p className="_property_auction_card_cont3">67% have this trait
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                        <div className="_property_auction_card">
                                            <h6 className="_property_auction_card_cont1">Eyes</h6>
                                            <p className="_property_auction_card_cont2">Flooting</p>
                                            <p className="_property_auction_card_cont3">2% have this trait
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                        <div className="_property_auction_card">
                                            <h6 className="_property_auction_card_cont1">Misc</h6>
                                            <p className="_property_auction_card_cont2">None</p>
                                            <p className="_property_auction_card_cont3">10% have this trait
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                        <div className="_property_auction_card">
                                            <h6 className="_property_auction_card_cont1">Mouth</h6>
                                            <p className="_property_auction_card_cont2">Beak</p>
                                            <p className="_property_auction_card_cont3">36% have this trait
                                            </p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default NftProperties;